module.exports = __webpack_public_path__ + "img/08.2a3b072b.jpg";